import { Autosuggest, Bleed, Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSetApidSubgroup } from '../../../r2imageBrowser/hooks'
import { useR2StateContext } from '../../../../providers/r2Provider/R2Context'

export default function ViewAnotherItemDialog({ overlay }) {
  const { close: closeOverlay } = overlay
  const { childGroups } = useR2StateContext()

  const [t] = useTranslation()
  const headingText = t('ViewAnotherItemDialog.navigateHeading', 'Navigate between items')
  const browseImagesButtonText = t('ViewAnotherItemDialog.browseImagesButtonText', 'Browse Images')
  const cancelButtonText = t('ViewAnotherItemDialog.cancelButtonText', 'Cancel')
  const autoSuggestLabel = t('ViewAnotherItemDialog.autoSuggestLabel', 'Item Number')
  const autoSuggestPlaceholder = t('ViewAnotherItemDialog.autoSuggestPlaceholder', 'Type or choose from list')
  const helpMessage = t(
    'ViewAnotherItemDialog.helpNavigateMessage',
    `The original image group has been divided into {number} groups of images called "items."`,
    {
      number: childGroups?.length ?? 0,
    }
  )

  const setItem = useSetApidSubgroup()

  const [selectedItem, setSelectedItem] = useState(null)

  const suggestions = useMemo(() => {
    const itemText = (itemNumber) => t('ViewAnotherItemDialog.itemText', `Item {itemNumber}`, { itemNumber })
    return childGroups
      ? childGroups.map((group, index) => {
          return {
            key: group.parentId,
            parentId: group.parentId,
            primaryText: itemText(index + 1),
            index,
          }
        })
      : []
  }, [t, childGroups])

  const handleBrowseImagesClick = useCallback(() => {
    if (selectedItem) setItem(selectedItem.parentId)
    closeOverlay()
  }, [closeOverlay, selectedItem, setItem])

  return (
    // Add subtitle back in if/when we can ask zion to truncate the string or allow a node to be passed in
    // <DialogOverlay {...overlay} title={headingText} subtitle={subHeadingText(getTitleFromGroup(initialGroup))}>
    <DialogOverlay {...overlay} title={headingText}>
      <Bleed bottom>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionSelected={setSelectedItem}
          label={autoSuggestLabel}
          placeholder={autoSuggestPlaceholder}
          helpMessage={helpMessage}
        />
      </Bleed>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={closeOverlay}>{cancelButtonText}</Button>
          <Button emphasis="high" disabled={!selectedItem} onClick={handleBrowseImagesClick}>
            {browseImagesButtonText}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
